// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__grTyE","wrapper":"styles_wrapper__CEDeU","logo":"styles_logo__yMmBH","content":"styles_content__Xhu+O"};